import gql from "graphql-tag"

export default gql`
  query searchCollection($text: String!) {
    search: tmdbSearchCollection(text: $text)
  }
`